import { useEffect, useState } from "react";
import { Wrench, Mail, AlertTriangle } from "lucide-react";
import { Button } from "../ui/button";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "../ui/select";
import { Table, TableHeader, TableRow, TableHead, TableBody, TableCell } from "../ui/table";
import { toast } from "sonner";
import api, { eur } from "../../lib/api";

export default function ComodatiPanel() {
  const [comodati, setComodati] = useState([]);
  const [comodatoAlerts, setComodatoAlerts] = useState([]);

  const load = async () => {
    const [c, ca] = await Promise.all([api.get("/comodati"), api.get("/comodati/alerts")]);
    setComodati(c.data); setComodatoAlerts(ca.data.alerts || []);
  };
  useEffect(() => { load().catch(() => {}); }, []);

  const setComodatoStatus = async (id, status) => { await api.put(`/comodati/${id}/status`, { status }); load(); };
  const sendComodatoReminders = async () => {
    try { const { data } = await api.post("/comodati/send-reminders"); toast.success(`Avviso scadenze: ${data.count} comodati${data.sent ? " · email inviata" : ""}`); }
    catch { toast.error("Invio non riuscito"); }
  };

  return (
    <div data-testid="comodati-panel">
      {comodatoAlerts.length > 0 && (
        <div className="mb-4 bg-amber-50 border border-amber-200 rounded-xl p-4" data-testid="comodato-alerts">
          <div className="flex items-center gap-2 text-amber-800 font-semibold mb-2"><AlertTriangle className="w-4 h-4" /> Comodati in scadenza (entro 30 giorni)</div>
          <div className="flex flex-wrap gap-2">
            {comodatoAlerts.map((a) => (
              <span key={a.id} className="text-xs bg-white border border-amber-200 rounded-full px-3 py-1">
                {a.client_name} · {a.machine_name} · {a.days_left < 0 ? `scaduto da ${-a.days_left}gg` : `tra ${a.days_left}gg`}
              </span>
            ))}
          </div>
        </div>
      )}
      <div className="flex justify-end mb-4">
        <Button onClick={sendComodatoReminders} variant="outline" data-testid="send-comodato-reminders-btn" className="rounded-full border-stone-300"><Mail className="w-4 h-4 mr-2" />Invia avviso scadenze</Button>
      </div>
      <div className="bg-white rounded-2xl border border-stone-200 overflow-x-auto">
        <Table>
          <TableHeader><TableRow><TableHead>Cliente</TableHead><TableHead>Agente</TableHead><TableHead>Impianto</TableHead><TableHead>Costo</TableHead><TableHead>Assorb./mese</TableHead><TableHead>Pareggio</TableHead><TableHead>Scadenza</TableHead><TableHead>Stato</TableHead></TableRow></TableHeader>
          <TableBody>
            {comodati.length === 0 && <TableRow><TableCell colSpan={8} className="text-center text-stone-400 py-8">Nessun comodato</TableCell></TableRow>}
            {comodati.map((c) => (
              <TableRow key={c.id} data-testid={`admin-comodato-${c.id}`}>
                <TableCell className="font-medium">{c.client_name}</TableCell>
                <TableCell>{c.agent_name}</TableCell>
                <TableCell>{c.machine_name}</TableCell>
                <TableCell className="font-mono">{eur(c.machine_cost)}</TableCell>
                <TableCell className="font-mono">{eur(c.monthly_absorption)}</TableCell>
                <TableCell className="font-mono text-[#9A3412] font-semibold">{c.breakeven_months ?? "—"} mesi</TableCell>
                <TableCell className="text-xs">{c.end_date ? new Date(c.end_date).toLocaleDateString("it-IT") : "—"}</TableCell>
                <TableCell>
                  <Select value={c.status} onValueChange={(v) => setComodatoStatus(c.id, v)}>
                    <SelectTrigger className="h-8 w-32" data-testid={`comodato-status-${c.id}`}><SelectValue /></SelectTrigger>
                    <SelectContent>
                      <SelectItem value="in_attesa">In attesa</SelectItem>
                      <SelectItem value="attivo">Attivo</SelectItem>
                      <SelectItem value="rifiutato">Rifiutato</SelectItem>
                    </SelectContent>
                  </Select>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
